import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      state: false,
    },
    user_profile: {
      state: false,
    },
    mai: {
      state: false,
    },
    notice: {
      state: false,
    },
    allList: {
      state: false,
    },
    cheersList: {
      state: false,
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user; //firebaseが返したユーザー情報
      state.user.state = true;
    },
    setProfile(state, data) {
      state.user_profile = data;
      state.user_profile.state = true;
    },
    setMai(state, data) {
      state.mai = data;
      state.mai.state = true;
    },
    setNotice(state, data) {
      state.notice = data;
    },
    setAllList(state, data) {
      state.allList = data;
    },
    setCheersList(state, data) {
      state.cheersList = data;
    },
  },
  actions: {
  },
  modules: {
  },
  getters: {
    user(state) {
      return state.user;
    },
    user_profile(state) {
      return state.user_profile;
    },
    mai(state) {
      return state.mai;
    },
    notice(state) {
      return state.notice;
    },
    allList(state) {
      return state.allList;
    },
    cheersList(state) {
      return state.cheersList;
    },
  }
})
